export default __webpack_public_path__ + "static/media/disneyClone.26c99845.png";